import {
    MAINTENANCE_WARNINGS_DETAILS_OPEN_MODAL,
    MAINTENANCE_WARNINGS_DETAILS_REQUEST,
    MAINTENANCE_WARNINGS_DETAILS_RESULT,
} from 'Redux/actionTypes';

export const maintenanceWarningsDetailsOpenModal = (open, data) => ({
    type: MAINTENANCE_WARNINGS_DETAILS_OPEN_MODAL,
    payload: { open, data }
})

export const  maintenanceWarningsDetailsRequest = (data, nextToken) => ({
    type: MAINTENANCE_WARNINGS_DETAILS_REQUEST,
    payload: { data, nextToken }
})

export const  maintenanceWarningsDetailsResult = (data) => ({
    type: MAINTENANCE_WARNINGS_DETAILS_RESULT,
    payload: { data }
})